import React, { Component } from 'react';
import cx from 'classnames';
import { Convert } from 'src/helpers';
import { IMAGES } from 'src/constants';
import styles from './offer-box.module.scss';

class OfferBox extends Component {
  render() {
    const { checkoutDetail, mainCheckoutDetail } = this.props;
    return (
      <div className={styles['offer-box-outer']}>
        <div className={styles['offer-box']}>
          <div className={styles['header']}>
            <div className={styles['inner-header']}>
              <div className={styles['sub-inner-header']}>
                <div className={styles['logo']}>
                  <img
                    src={checkoutDetail?.oneClickCheckout?.partner?.logo || IMAGES.MOTILAL_OSWAL}
                    alt="img"
                  />
                </div>
                <div className={styles['content']}>
                  <div className={styles['title']}>
                    {Convert.toCapitalizeLetters(
                      checkoutDetail?.oneClickCheckout?.partner?.name ||
                        checkoutDetail?.oneClickCheckout?.amcName,
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <>
            <div className={cx('mb-3', styles['progress-bar'])} />

            <div className={styles['info']}>Your information</div>

            <div className={styles['info-box']}>
              <div className={styles['info-box-content']}>
                <div className={styles['info-box-left']}>
                  <img src="/images/user-trans.svg" alt="img" />
                </div>
                <div className={styles['info-box-right']}>
                  <div className={styles['info-box-title']}>Customer Name</div>
                  <div className={styles['info-box-title-name']}>
                    {checkoutDetail?.oneClickCheckout?.name || '-'}
                  </div>
                </div>
              </div>
            </div>

            <div className={styles['info-box']}>
              <div className={styles['info-box-content']}>
                <div className={styles['info-box-left']}>
                  <img src="/images/hash.svg" alt="img" />
                </div>
                <div className={styles['info-box-right']}>
                  <div className={styles['info-box-title']}>Folio Number</div>
                  <div className={styles['info-box-title-name']}>
                    {checkoutDetail?.oneClickCheckout?.folioNumber || '-'}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles['know-more']}>
              Know more about{' '}
              <span>{Convert.toCapitalizeLetters(checkoutDetail?.oneClickCheckout?.fundName)}</span>
            </div>

            <div className={styles['encrypt']}>
              <div className={styles['encrypt-title']}>FOR ANY HELP, REACH OUT TO US ON</div>
              <div className={styles['encrypt-content']}>
                <div className={styles['encrypt-left']}>
                  <a
                    href={`https://wa.me/whatsappphonenumber?text=${
                      checkoutDetail?.oneClickCheckout?.partner?.supportPhoneNumber ||
                      mainCheckoutDetail?.oneClickCheckout?.partner?.supportPhoneNumber
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {checkoutDetail?.oneClickCheckout?.partner?.supportPhoneNumber ||
                      mainCheckoutDetail?.oneClickCheckout?.partner?.supportPhoneNumber}
                  </a>
                </div>
                <div className={styles['encrypt-right']}>
                  <a
                    href={`mailto:${
                      checkoutDetail?.oneClickCheckout?.partner?.supportEmail ||
                      mainCheckoutDetail?.oneClickCheckout?.partner?.supportEmail
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {checkoutDetail?.oneClickCheckout?.partner?.supportEmail ||
                      mainCheckoutDetail?.oneClickCheckout?.partner?.supportEmail}
                  </a>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    );
  }
}

export default OfferBox;
